import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";
import { Table, Tooltip } from "antd";
//import Data from "../assets/jsons/customers";
import { useAuth } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import api from "../api/api"
import {
    onShowSizeChange,
    itemRender,
    showTotal
} from "../_components/paginationfunction";
import { avatar10, filterIcon } from "../_components/Imagepath";
// import AddVendor from "../customers/vendors/addVendor";
import AddVendor from "./AddVendor";
import VendorInvitationsMobile from "./VendorInvitationsMobile";
import { useTranslation } from "react-i18next";
const VendorInvitations = () => {
  const { t } = useTranslation();
  const {user} = useAuth();
  const history = useHistory();

  useEffect(()=>{
    fetchData()
  },[])
  
  const [loadingInvitation, setloadingInvitation] = useState(false);
  const [error, setError] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  
  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);

  const fetchData = async (page = 1) => {
    setloadingInvitation(true)
    setError(null)

    try {
      let typeurl =`/agency-invite-supplier/?page=${page}`;

      const response = await api.get(typeurl); // No need to wrap `data` in an object

      setData(response.data.results)
      setNextPage(response.data.next)
      setPrevPage(response.data.previous)
      setCount(response.data.count)

    } catch (error) {
      //console.error("Error submitting form:", error);
      console.log( error);
      // Extract response code if available
      const responseCode = error.response.data.detail ? error.response.data.detail : "Unknown";
      
      setError(responseCode)
      console.log("Response Code:", responseCode);
    } finally {
      setloadingInvitation(false);
    }
  }

  const handlePageChange = (page) => {
    if(page < 1 || page > Math.ceil(count / 10)) return;
    setCurrentPage(page);
    fetchData(page);
  };

  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);

  const toggleMobileMenu = () => {
      setMenu(!menu);
  };

  const columns = [
    {
      title: "#",
      //dataIndex: "id",
      render: (text, record, index) => index + 1,
      sorter: false,
    },
    {
      title: t("Email"),
      dataIndex: "email",
      sorter: (a, b) => a.Name.length - b.Name.length,
    },
    {
      title: t("Status"),
      dataIndex: "used",
      render: (value) => (
        <div>
          {value ?  <span className="badge badge-pill bg-success-light">{t("Accepted")}</span> :  
            <span className="badge badge-pill bg-info">{t("Pending")}</span>}
        </div>
      ),
      sorter: (a, b) => a.Status.length - b.Status.length,
    },
    /*{
      title: t("Verification Token"),
      dataIndex: "token",
        
    },
    {
      title: t("Created At"),
      dataIndex: "created_at",
      sorter: (a, b) => a.Created.length - b.Created.length,
    },*/
      
  ];

  const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          {(loadingInvitation || error) ? (
            <div style={{ textAlign: "center", margin: "10em" }}>
              {loadingInvitation && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
              {error && (
                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Error!</strong> {error}
                  {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                    Try Again
                  </button>*/}
                </div>
              )}
            </div>
          ) : (
            <> 
              <div className="content container-fluid">
                {/* Page Header */}
                <div className="page-header">
                  <div className="content-page-header ">
                    <h5>Invite Vendor</h5>
                    <div className="list-btn">
                      <ul className="filter-list">
                        <li>
                          <a
                            className="btn btn-primary"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#add_vendor"
                          >
                            <i
                              className="fa fa-plus-circle me-2"
                              aria-hidden="true"
                            />
                            {t("Add Vendor")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                
                {data.length === 0 && (
                  <div className="text-center mt-5 py-5">
                    <div className="mb-4">
                      <div className="mb-3">
                        <i className="fas fa-paper-plane text-muted" style={{fontSize: '4rem', opacity: 0.3}}></i>
                      </div>
                      <h4 className="text-muted mb-2">{t("No Invitations Yet")}</h4>
                      <p className="text-muted mb-4">{t("You haven't sent any vendor invitations yet. Start by inviting vendors to connect.")}</p>
                    </div>
                    <div className="d-flex gap-3 justify-content-center flex-wrap">
                      <a
                        className="btn btn-primary px-4 py-2 rounded-pill shadow-sm"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#add_vendor"
                      >
                        <i className="fas fa-plus me-2"></i>
                        {t("Add Vendor")}
                      </a>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col-sm-12">
                    {isMobileDevice() || screenWidth <= 576 ? (
                      <>
                        <VendorInvitationsMobile handlePageChange={handlePageChange} currentPage={currentPage} nextPage={nextPage} prevPage={prevPage} count={count} data={data} screenWidth={screenWidth}/>
                      </>
                    ) : (
                      <div className="card">
                        <div className="card-body">
                          <div className="table-responsive table-hover">
                            <Table
                              className="table"
                              pagination={{
                                total: count,
                                current: currentPage, 
                                onShowSizeChange: onShowSizeChange,
                                showTotal: (length,range) => showTotal(t,length, range),
                                itemRender:  (page, type, originalElement) => itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement),
                              }}
                              columns={columns}
                              dataSource={data}
                              rowKey={(record) => record.id}
                            />
                          </div>
                        </div>
                      </div>
                    )}   
                    </div>
                </div>
              </div>
            </>
          )}
        </div>
        {/*Add Vendor  */}
        <AddVendor onRefresh={fetchData}/>
      </div>
    </>
  );
};

export default VendorInvitations;
